// App.js - Updated with promotions route
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Header from './components/Header';
import HomePage from './pages/Home';
import FavoritesPage from './pages/Favorites';
import ProfilePage from './pages/Profile';
import SearchPage from './pages/Search';
import CreateBrandPage from './pages/brand/CreateBrand';
import EditBrandPage from './pages/brand/EditBrand';
import MyBrandsPage from './pages/MyBrands';
import BrandSinglePage from './pages/BrandSingle';
import PromotionsPage from './pages/Promotions'; // Import the new Promotions page
import BrandsPage from './pages/Brands'; // Import the new Brands page
import WelcomeBonusPage from './pages/WelcomeBonus'; // Import the Welcome Bonus page
import Admin from './pages/Admin'; // Import the Admin page
import AdminReports from './pages/AdminReports'; // Import the Admin Reports page
import AdminComments from './pages/AdminComments'; // Import the Admin Comments page
import UserTransactions from './pages/UserTransactions'; // Import the User Transactions page
import Migration from './pages/Migration'; // Import the migration page
import { AuthProvider } from './context/AuthContext';

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <Router>
          <div className="flex flex-col min-h-screen bg-gray-50">
            <Header />
            <main className="flex-grow">
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/favorites" element={<FavoritesPage />} />
                <Route path="/search" element={<SearchPage />} />
                <Route path="/profile" element={<ProfilePage />} />
                <Route path="/create-brand" element={<CreateBrandPage />} />
                <Route path="/edit-brand/:id" element={<EditBrandPage />} />
                <Route path="/mybrands" element={<MyBrandsPage />} />
                <Route path="/bycategory" element={<PromotionsPage />} /> {/* Add the new Promotions route */}
                <Route path="/bybrands" element={<BrandsPage />} /> {/* Add the new Brands route */}
                <Route path="/welcomebonus" element={<WelcomeBonusPage />} /> {/* Add the Welcome Bonus route */}
                <Route path="/admin" element={<Admin />} /> {/* Add the Admin page */}
                <Route path="/admin/reports" element={<AdminReports />} /> {/* Add the Admin Reports route */}
                <Route path="/admin/comments" element={<AdminComments />} /> {/* Add the Admin Comments route */}
                <Route path="/admin/brand/edit/:id" element={<EditBrandPage />} /> {/* Add the Admin Brand Edit route */}
                <Route path="/transactions" element={<UserTransactions />} /> {/* Add the User Transactions route */}
                <Route path="/migration" element={<Migration />} /> {/* Temporary migration tool */}

                {/* Brand viewing route using slug */}
                <Route path="/brand/:slug" element={<BrandSinglePage />} />
              </Routes>
            </main>
          </div>
        </Router>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;